var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "header",
            [
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12", md: "6" } }, [
                    _c("header", [_c("Breadcrumb")], 1)
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "text-right",
                      attrs: { cols: "12", md: "6" }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _vm.showWorkFlow
                                ? _c("GetFormField", {
                                    attrs: { "hide-edit": true },
                                    model: {
                                      value: _vm.workFlowModel,
                                      callback: function($$v) {
                                        _vm.workFlowModel = $$v
                                      },
                                      expression: "workFlowModel"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "KeyAccount" } } },
                                [_c("CancelButton")],
                                1
                              ),
                              _vm._v(" "),
                              _c("AddButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.save()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "LocationModal",
              attrs: {
                id: "location-modal",
                "hide-footer": "",
                "hide-header": ""
              }
            },
            [_c("NextLocation", { attrs: { Location: _vm.Location } })],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code,
                          md: "3",
                          lg: "3"
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "CardTypeId",
                        error: _vm.$v.form.CardTypeId,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.CardTypeId,
                          url: "VisionNextCustomer/api/CustomerCardType/Search"
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType("CardTypeId", $event)
                          }
                        },
                        model: {
                          value: _vm.CardType,
                          callback: function($$v) {
                            _vm.CardType = $$v
                          },
                          expression: "CardType"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusReasonId",
                        error: _vm.$v.form.StatusReasonId,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.StatusReasonId,
                          url: "VisionNextCommonApi/api/CancelReason/Search"
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType(
                              "StatusReasonId",
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.StatusReason,
                          callback: function($$v) {
                            _vm.StatusReason = $$v
                          },
                          expression: "StatusReason"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          disabled: _vm.insertReadonly.StatusId,
                          type: "number",
                          toggle: ""
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.RecordTypeId === 4 && _vm.upperCustomer !== null
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12", lg: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t("insert.customer.mainOfBranch")
                              }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "/Update/KeyAccount/" +
                                      _vm.upperCustomer.DecimalValue
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.upperCustomer.Code) +
                                      " - " +
                                      _vm._s(_vm.upperCustomer.Label)
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: { title: _vm.$t("insert.customer.Customer") },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CommercialTitle",
                            error: _vm.$v.form.CommercialTitle,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.CommercialTitle
                            },
                            model: {
                              value: _vm.form.CommercialTitle,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "CommercialTitle", $$v)
                              },
                              expression: "form.CommercialTitle"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Description1",
                            error: _vm.$v.form.Description1,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Description1
                            },
                            model: {
                              value: _vm.form.Description1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Description1", $$v)
                              },
                              expression: "form.Description1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "LicenseNumber",
                            error: _vm.$v.form.LicenseNumber,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              maxLength: "12",
                              oninput: _vm.maxLengthControl,
                              disabled: _vm.insertReadonly.LicenseNumber
                            },
                            model: {
                              value: _vm.form.LicenseNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "LicenseNumber", $$v)
                              },
                              expression: "form.LicenseNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TaxCustomerTypeId",
                            error: _vm.$v.form.TaxCustomerTypeId,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.TaxCustomerTypeId,
                              "lookup-key": "TAX_CUSTOMER_TYPE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "TaxCustomerTypeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.TaxCustomerType,
                              callback: function($$v) {
                                _vm.TaxCustomerType = $$v
                              },
                              expression: "TaxCustomerType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TaxOffice",
                            error: _vm.$v.form.TaxOffice,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.TaxOffice
                            },
                            model: {
                              value: _vm.form.TaxOffice,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "TaxOffice", $$v)
                              },
                              expression: "form.TaxOffice"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TaxNumber",
                            error: _vm.$v.form.TaxNumber,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.TaxNumber,
                              maxLength: _vm.taxNumberReq,
                              oninput: _vm.maxLengthControl
                            },
                            model: {
                              value: _vm.form.TaxNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "TaxNumber", $$v)
                              },
                              expression: "form.TaxNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Alias",
                            error: _vm.$v.form.Alias,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Alias
                            },
                            model: {
                              value: _vm.form.Alias,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Alias", $$v)
                              },
                              expression: "form.Alias"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TradeLicenseNumber",
                            error: _vm.$v.form.TradeLicenseNumber,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.TradeLicenseNumber
                            },
                            model: {
                              value: _vm.form.TradeLicenseNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "TradeLicenseNumber", $$v)
                              },
                              expression: "form.TradeLicenseNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BlockReasonId",
                            error: _vm.$v.form.BlockReasonId,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "CUSTOMER_BLOCK_REASON",
                              disabled: _vm.insertReadonly.BlockReasonId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("BlockReasonId", $event)
                              }
                            },
                            model: {
                              value: _vm.BlockReason,
                              callback: function($$v) {
                                _vm.BlockReason = $$v
                              },
                              expression: "BlockReason"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TypeId",
                            error: _vm.$v.form.TypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.TypeId,
                              "lookup-key": "CUSTOMER_TYPE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("TypeId", $event)
                              }
                            },
                            model: {
                              value: _vm.Type,
                              callback: function($$v) {
                                _vm.Type = $$v
                              },
                              expression: "Type"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerInvoiceTypeId",
                            error: _vm.$v.form.CustomerInvoiceTypeId,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled:
                                _vm.insertReadonly.CustomerInvoiceTypeId,
                              "lookup-key": "CUSTOMER_INVOICE_TYPE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "CustomerInvoiceTypeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.CustomerInvoiceType,
                              callback: function($$v) {
                                _vm.CustomerInvoiceType = $$v
                              },
                              expression: "CustomerInvoiceType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerRegion5Id",
                            error: _vm.$v.form.customerRegion5Id,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.customerRegion5Id,
                              "lookup-key": "CUSTOMER_REGION_5"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "CustomerRegion5Id",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.CustomerRegion5,
                              callback: function($$v) {
                                _vm.CustomerRegion5 = $$v
                              },
                              expression: "CustomerRegion5"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "MarketingRegion5Id",
                            error: _vm.$v.form.MarketingRegion5Id,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.MarketingRegion5Id,
                              "lookup-key": "MARKETING_REGION_5"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "MarketingRegion5Id",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.MarketingRegion5,
                              callback: function($$v) {
                                _vm.MarketingRegion5 = $$v
                              },
                              expression: "MarketingRegion5"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RouteCode",
                            error: _vm.$v.form.RouteCode,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.RouteCode
                            },
                            model: {
                              value: _vm.form.RouteCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "RouteCode", $$v)
                              },
                              expression: "form.RouteCode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "LicenseValidDate",
                            error: _vm.$v.form.LicenseValidDate,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: {
                              disabled: _vm.insertReadonly.LicenseValidDate
                            },
                            model: {
                              value: _vm.form.LicenseValidDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "LicenseValidDate", $$v)
                              },
                              expression: "form.LicenseValidDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "IsBlocked",
                            error: _vm.$v.form.IsBlocked,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.IsBlocked
                            },
                            model: {
                              value: _vm.form.IsBlocked,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "IsBlocked", $$v)
                              },
                              expression: "form.IsBlocked"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "IsOrderChangeUnitary",
                            error: _vm.$v.form.IsOrderChangeUnitary,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: { type: "number", toggle: "" },
                            model: {
                              value: _vm.form.IsOrderChangeUnitary,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "IsOrderChangeUnitary", $$v)
                              },
                              expression: "form.IsOrderChangeUnitary"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "UseEDispatch",
                            error: _vm.$v.form.UseEDispatch,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: { type: "number", toggle: "" },
                            model: {
                              value: _vm.form.UseEDispatch,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "UseEDispatch", $$v)
                              },
                              expression: "form.UseEDispatch"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "IsWarehouseSale",
                            error: _vm.$v.form.IsWarehouseSale,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: { type: "number", toggle: "" },
                            model: {
                              value: _vm.form.IsWarehouseSale,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "IsWarehouseSale", $$v)
                              },
                              expression: "form.IsWarehouseSale"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "UseEInvoice",
                            error: _vm.$v.form.UseEInvoice,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: { type: "number", toggle: "" },
                            model: {
                              value: _vm.form.UseEInvoice,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "UseEInvoice", $$v)
                              },
                              expression: "form.UseEInvoice"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.Code
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        title: _vm.$t("insert.customer.CustomerLocations")
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.tabValidation()
                        }
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: {
                          items: _vm.locationItems,
                          "main-form": _vm.form,
                          "detail-buttons": _vm.detailButtons
                        },
                        model: {
                          value: _vm.form.CustomerLocations,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "CustomerLocations", $$v)
                          },
                          expression: "form.CustomerLocations"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: { title: _vm.$t("insert.customer.CustomerClass") },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Category3Id",
                            error: _vm.$v.form.Category3Id
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.Category3Id,
                              "lookup-key": "CUSTOMER_CATEGORY_3"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("Category3Id", $event)
                              }
                            },
                            model: {
                              value: _vm.Category3,
                              callback: function($$v) {
                                _vm.Category3 = $$v
                              },
                              expression: "Category3"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Category2Id",
                            error: _vm.$v.form.Category2Id
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: true,
                              "lookup-key": "CUSTOMER_CATEGORY_2"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("Category2Id", $event)
                              }
                            },
                            model: {
                              value: _vm.Category2,
                              callback: function($$v) {
                                _vm.Category2 = $$v
                              },
                              expression: "Category2"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Category1Id",
                            error: _vm.$v.form.Category1Id
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: true,
                              "lookup-key": "CUSTOMER_CATEGORY_1"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("Category1Id", $event)
                              }
                            },
                            model: {
                              value: _vm.Category1,
                              callback: function($$v) {
                                _vm.Category1 = $$v
                              },
                              expression: "Category1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "GroupId",
                            error: _vm.$v.form.GroupId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "CUSTOMER_GROUP",
                              disabled: _vm.insertReadonly.GroupId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("GroupId", $event)
                              }
                            },
                            model: {
                              value: _vm.Group,
                              callback: function($$v) {
                                _vm.Group = $$v
                              },
                              expression: "Group"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ClassId",
                            error: _vm.$v.form.ClassId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "CUSTOMER_CLASS",
                              disabled: _vm.insertReadonly.ClassId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("ClassId", $event)
                              }
                            },
                            model: {
                              value: _vm.Class,
                              callback: function($$v) {
                                _vm.Class = $$v
                              },
                              expression: "Class"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "SalesDocumentTypeId",
                            error: _vm.$v.form.SalesDocumentTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.SalesDocumentTypeId,
                              "lookup-key": "SALES_DOCUMENT_TYPE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "SalesDocumentTypeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.SalesDocumentType,
                              callback: function($$v) {
                                _vm.SalesDocumentType = $$v
                              },
                              expression: "SalesDocumentType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "OwnerTypeId",
                            error: _vm.$v.form.OwnerTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.OwnerTypeId,
                              "lookup-key": "OWNER_TYPE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("OwnerTypeId", $event)
                              }
                            },
                            model: {
                              value: _vm.OwnerType,
                              callback: function($$v) {
                                _vm.OwnerType = $$v
                              },
                              expression: "OwnerType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ClassProposalId",
                            error: _vm.$v.form.ClassProposalId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.ClassProposalId,
                              "lookup-key": "CUSTOMER_CLASS_PROPOSAL"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "ClassProposalId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.ClassProposal,
                              callback: function($$v) {
                                _vm.ClassProposal = $$v
                              },
                              expression: "ClassProposal"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "SalesMethodId",
                            error: _vm.$v.form.SalesMethodId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.SalesMethodId,
                              "lookup-key": "CUSTOMER_SALES_METHOD"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("SalesMethodId", $event)
                              }
                            },
                            model: {
                              value: _vm.SalesMethod,
                              callback: function($$v) {
                                _vm.SalesMethod = $$v
                              },
                              expression: "SalesMethod"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "GeographicEnvironmentId",
                            error: _vm.$v.form.GeographicEnvironmentId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled:
                                _vm.insertReadonly.GeographicEnvironmentId,
                              "lookup-key": "CUSTOMER_GEOGRAPHIC_ENVIRONMENT"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "GeographicEnvironmentId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.GeographicEnvironment,
                              callback: function($$v) {
                                _vm.GeographicEnvironment = $$v
                              },
                              expression: "GeographicEnvironment"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TradeFocusId",
                            error: _vm.$v.form.TradeFocusId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.TradeFocusId,
                              "lookup-key": "CUSTOMER_TRADE_FOCUS"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("TradeFocusId", $event)
                              }
                            },
                            model: {
                              value: _vm.TradeFocus,
                              callback: function($$v) {
                                _vm.TradeFocus = $$v
                              },
                              expression: "TradeFocus"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "InvoiceCombineRuleId",
                            error: _vm.$v.form.InvoiceCombineRuleId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.InvoiceCombineRuleId,
                              "lookup-key": "INVOICE_COMBINE_RULE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "InvoiceCombineRuleId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.InvoiceCombineRule,
                              callback: function($$v) {
                                _vm.InvoiceCombineRule = $$v
                              },
                              expression: "InvoiceCombineRule"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ClassProposalReasonId",
                            error: _vm.$v.form.ClassProposalReasonId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled:
                                _vm.insertReadonly.ClassProposalReasonId,
                              "lookup-key": "CUSTOMER_CLASS_PROPOSAL_REASON"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "ClassProposalReasonId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.ClassProposalReason,
                              callback: function($$v) {
                                _vm.ClassProposalReason = $$v
                              },
                              expression: "ClassProposalReason"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BackMarginGroupId",
                            error: _vm.$v.form.BackMarginGroupId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.BackMarginGroupId,
                              "lookup-key": "BACK_MARGIN_GROUP"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "BackMarginGroupId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.BackMarginGroup,
                              callback: function($$v) {
                                _vm.BackMarginGroup = $$v
                              },
                              expression: "BackMarginGroup"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "KindId",
                            error: _vm.$v.form.KindId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.KindId,
                              "lookup-key": "CUSTOMER_KIND"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("KindId", $event)
                              }
                            },
                            model: {
                              value: _vm.Kind,
                              callback: function($$v) {
                                _vm.Kind = $$v
                              },
                              expression: "Kind"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.RecordTypeId === 3
                ? _c(
                    "b-tab",
                    {
                      attrs: { title: _vm.$t("insert.customer.Branchs") },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.tabValidation()
                        }
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "ml-auto",
                              attrs: { cols: "12", md: "3", lg: "2" }
                            },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("AddDetailButton", {
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.addBranch($event)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t("insert.customer.Branchs")
                              }
                            },
                            [
                              _c("NextInput", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.searchValue,
                                  callback: function($$v) {
                                    _vm.searchValue = $$v
                                  },
                                  expression: "searchValue"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-table-simple",
                            {
                              attrs: {
                                id: "searched-customer-list",
                                "current-page": _vm.currentPage,
                                "per-page": 0,
                                bordered: "",
                                small: ""
                              }
                            },
                            [
                              _c(
                                "b-thead",
                                [
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("insert.customer.BranchCode")
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("insert.customer.BranchName")
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.customer.AuthorizedBranch"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("list.operations")))
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tbody",
                                _vm._l(_vm.branchs, function(b, i) {
                                  return _c(
                                    "b-tr",
                                    { key: i },
                                    [
                                      _c("b-td", [_vm._v(_vm._s(b.Code))]),
                                      _vm._v(" "),
                                      _c("b-td", [
                                        _vm._v(_vm._s(b.Description1))
                                      ]),
                                      _vm._v(" "),
                                      _c("b-td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.allBranchs != null &&
                                              _vm.allBranchs.length > 0
                                              ? _vm.allBranchs.find(function(
                                                  x
                                                ) {
                                                  return (
                                                    x.RecordId === b.BranchId
                                                  )
                                                }).Description1
                                              : ""
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-td",
                                        { staticClass: "text-center" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "/Update/KeyAccount/" +
                                                  b.RecordId
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-edit text-success"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-pagination", {
                            attrs: {
                              "total-rows": _vm.totalRowCount,
                              "per-page": 20,
                              "aria-controls": "searched-customer-list"
                            },
                            model: {
                              value: _vm.currentPage,
                              callback: function($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.customer.CustomerFinancialInfo")
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "PriceListCategoryId",
                            error: _vm.$v.form.PriceListCategoryId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.PriceListCategoryId,
                              "lookup-key": "PRICE_LIST_CATEGORY_TYPE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "PriceListCategoryId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.PriceListCategory,
                              callback: function($$v) {
                                _vm.PriceListCategory = $$v
                              },
                              expression: "PriceListCategory"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CreditLimit",
                            error: _vm.$v.form.CreditLimit
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.CreditLimit
                            },
                            model: {
                              value: _vm.form.CreditLimit,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "CreditLimit", $$v)
                              },
                              expression: "form.CreditLimit"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RiskLimit",
                            error: _vm.$v.form.RiskLimit
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.RiskLimit
                            },
                            model: {
                              value: _vm.form.RiskLimit,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "RiskLimit", $$v)
                              },
                              expression: "form.RiskLimit"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CurrentCredit",
                            error: _vm.$v.form.CurrentCredit
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.CurrentCredit
                            },
                            model: {
                              value: _vm.form.CurrentCredit,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "CurrentCredit", $$v)
                              },
                              expression: "form.CurrentCredit"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CurrentRisk",
                            error: _vm.$v.form.CurrentRisk
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.CurrentRisk
                            },
                            model: {
                              value: _vm.form.CurrentRisk,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "CurrentRisk", $$v)
                              },
                              expression: "form.CurrentRisk"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ReservedLimit",
                            error: _vm.$v.form.ReservedLimit
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.ReservedLimit
                            },
                            model: {
                              value: _vm.form.ReservedLimit,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ReservedLimit", $$v)
                              },
                              expression: "form.ReservedLimit"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "FinanceCode",
                            error: _vm.$v.form.FinanceCode
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.FinanceCode
                            },
                            model: {
                              value: _vm.form.FinanceCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "FinanceCode", $$v)
                              },
                              expression: "form.FinanceCode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ZdebitAccountRemainder",
                            error: _vm.$v.form.ZdebitAccountRemainder
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled:
                                _vm.insertReadonly.ZdebitAccountRemainder
                            },
                            model: {
                              value: _vm.form.ZdebitAccountRemainder,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "ZdebitAccountRemainder",
                                  $$v
                                )
                              },
                              expression: "form.ZdebitAccountRemainder"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ZcreditAccountRemainder",
                            error: _vm.$v.form.ZcreditAccountRemainder
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled:
                                _vm.insertReadonly.ZcreditAccountRemainder
                            },
                            model: {
                              value: _vm.form.ZcreditAccountRemainder,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "ZcreditAccountRemainder",
                                  $$v
                                )
                              },
                              expression: "form.ZcreditAccountRemainder"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DiscountPercent1",
                            error: _vm.$v.form.DiscountPercent1
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.DiscountPercent1
                            },
                            model: {
                              value: _vm.form.DiscountPercent1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "DiscountPercent1", $$v)
                              },
                              expression: "form.DiscountPercent1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DiscountPercent2",
                            error: _vm.$v.form.DiscountPercent2
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.DiscountPercent2
                            },
                            model: {
                              value: _vm.form.DiscountPercent2,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "DiscountPercent2", $$v)
                              },
                              expression: "form.DiscountPercent2"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "SapCustomerId",
                            error: _vm.$v.form.SapCustomerId
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.SapCustomerId
                            },
                            model: {
                              value: _vm.form.SapCustomerId,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "SapCustomerId", $$v)
                              },
                              expression: "form.SapCustomerId"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DeliveryDayParam",
                            error: _vm.$v.form.DeliveryDayParam
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.DeliveryDayParam
                            },
                            model: {
                              value: _vm.form.DeliveryDayParam,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "DeliveryDayParam", $$v)
                              },
                              expression: "form.DeliveryDayParam"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "PaymentPeriod",
                            error: _vm.$v.form.PaymentPeriod
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled:
                                !(
                                  _vm.DefaultPaymentType &&
                                  _vm.DefaultPaymentType.Code == "AH"
                                ) || _vm.insertReadonly.PaymentPeriod,
                              url: "VisionNextCommonApi/api/FixedTerm/Search"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "PaymentPeriod",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.PaymentPeriod,
                              callback: function($$v) {
                                _vm.PaymentPeriod = $$v
                              },
                              expression: "PaymentPeriod"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TCIBreak1Id",
                            error: _vm.$v.form.TCIBreak1Id
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.TCIBreak1Id,
                              "lookup-key": "TCI_BREAKDOWN"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("TCIBreak1Id", $event)
                              }
                            },
                            model: {
                              value: _vm.TCIBreak1,
                              callback: function($$v) {
                                _vm.TCIBreak1 = $$v
                              },
                              expression: "TCIBreak1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TCIBreak2Id",
                            error: _vm.$v.form.TCIBreak2Id
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.TCIBreak2Id,
                              "lookup-key": "TCI_BREAKDOWN"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("TCIBreak2Id", $event)
                              }
                            },
                            model: {
                              value: _vm.TCIBreak2,
                              callback: function($$v) {
                                _vm.TCIBreak2 = $$v
                              },
                              expression: "TCIBreak2"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "StatementDay",
                            error: _vm.$v.form.StatementDay
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled:
                                _vm.insertReadonly.StatementDay ||
                                !_vm.form.Statement,
                              url: "VisionNextSystem/api/SysDay/Search"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "StatementDay",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.StatementDay,
                              callback: function($$v) {
                                _vm.StatementDay = $$v
                              },
                              expression: "StatementDay"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DefaultPaymentTypeId",
                            error: _vm.$v.form.DefaultPaymentTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.DefaultPaymentTypeId,
                              url: "VisionNextCommonApi/api/PaymentType/Search"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "DefaultPaymentTypeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.DefaultPaymentType,
                              callback: function($$v) {
                                _vm.DefaultPaymentType = $$v
                              },
                              expression: "DefaultPaymentType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "AllowOverLimit",
                            error: _vm.$v.form.AllowOverLimit
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.AllowOverLimit
                            },
                            model: {
                              value: _vm.form.AllowOverLimit,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "AllowOverLimit", $$v)
                              },
                              expression: "form.AllowOverLimit"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "IsDirectDebit",
                            error: _vm.$v.form.IsDirectDebit
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled:
                                _vm.insertReadonly.IsDirectDebit ||
                                _vm.DefaultPaymentType.Code !== "AH"
                            },
                            model: {
                              value: _vm.form.IsDirectDebit,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "IsDirectDebit", $$v)
                              },
                              expression: "form.IsDirectDebit"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ManualInvoiceClosure",
                            error: _vm.$v.form.ManualInvoiceClosure
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.ManualInvoiceClosure
                            },
                            model: {
                              value: _vm.form.ManualInvoiceClosure,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ManualInvoiceClosure", $$v)
                              },
                              expression: "form.ManualInvoiceClosure"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Statement",
                            error: _vm.$v.form.Statement
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.Statement
                            },
                            model: {
                              value: _vm.form.Statement,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Statement", $$v)
                              },
                              expression: "form.Statement"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.customer.CustomerCreditHistories")
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: { items: _vm.customerCreditHistoriesItems },
                    model: {
                      value: _vm.form.CustomerCreditHistories,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "CustomerCreditHistories", $$v)
                      },
                      expression: "form.CustomerCreditHistories"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.customer.CustomerPaymentTypes")
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: { items: _vm.paymentTypesItems },
                    model: {
                      value: _vm.form.CustomerPaymentTypes,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "CustomerPaymentTypes", $$v)
                      },
                      expression: "form.CustomerPaymentTypes"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: { title: _vm.$t("insert.customer.detail") },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TextField1",
                            error: _vm.$v.form.TextField1,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              toggle: "",
                              disabled: _vm.insertReadonly.TextField1
                            },
                            model: {
                              value: _vm.form.TextField1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "TextField1", $$v)
                              },
                              expression: "form.TextField1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TextField2",
                            error: _vm.$v.form.TextField2,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              toggle: "",
                              disabled: _vm.insertReadonly.TextField2
                            },
                            model: {
                              value: _vm.form.TextField2,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "TextField2", $$v)
                              },
                              expression: "form.TextField2"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Barcode",
                            error: _vm.$v.form.Barcode,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              toggle: "",
                              disabled: _vm.insertReadonly.Barcode
                            },
                            model: {
                              value: _vm.form.Barcode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Barcode", $$v)
                              },
                              expression: "form.Barcode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "HoldsAsset",
                            error: _vm.$v.form.HoldsAsset,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "CUSTOMER_HOLD_ASSET",
                              disabled: _vm.insertReadonly.HoldsAsset
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("HoldsAsset", $event)
                              }
                            },
                            model: {
                              value: _vm.HoldsAsset,
                              callback: function($$v) {
                                _vm.HoldsAsset = $$v
                              },
                              expression: "HoldsAsset"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Contracted",
                            error: _vm.$v.form.Contracted,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "CUSTOMER_CONTRACTED",
                              disabled: _vm.insertReadonly.Contracted
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("Contracted", $event)
                              }
                            },
                            model: {
                              value: _vm.Contracted,
                              callback: function($$v) {
                                _vm.Contracted = $$v
                              },
                              expression: "Contracted"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.customer.CustomerItemDiscountCrts")
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: { items: _vm.customerDiscountsItems },
                    model: {
                      value: _vm.form.CustomerItemDiscounts,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "CustomerItemDiscounts", $$v)
                      },
                      expression: "form.CustomerItemDiscounts"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: { title: _vm.$t("insert.customer.tag") },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: { items: _vm.customerLabelItems },
                    model: {
                      value: _vm.form.CustomerLabels,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "CustomerLabels", $$v)
                      },
                      expression: "form.CustomerLabels"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: { title: _vm.$t("insert.customer.ECustomerAliases") },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: { items: _vm.eCustomerAliasesItems },
                    model: {
                      value: _vm.form.ECustomerAliases,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "ECustomerAliases", $$v)
                      },
                      expression: "form.ECustomerAliases"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e067f94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e067f94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/KeyAccount/update.vue
// module id = null
// module chunks = 